interface AuditSourceReference {
  documentId: string;
  label: string;
}

const INTERNAL_ID = /\b[0-9a-f]{24}\b/gi;

export const hasInternalAuditId = (text: string): boolean =>
  /\b[0-9a-f]{24}\b/i.test(text);

/** Historic model notes may mention Mongo IDs; show the cited entry instead. */
export const displayAuditText = (text: string, sources: readonly AuditSourceReference[]): string => {
  const labels = new Map(sources.map((source) => [source.documentId.toLowerCase(), source.label]));
  return text.replace(INTERNAL_ID, (id) => {
    const label = labels.get(id.toLowerCase())?.replace(INTERNAL_ID, 'affected entry').trim();
    return label ? `“${label}”` : 'the affected entry';
  });
};

/** Keep model explanations scannable; the full entry labels appear below them. */
export const displayAuditRecommendation = (text: string, sources: readonly AuditSourceReference[]): string =>
  [...sources].sort((left, right) => right.label.length - left.label.length).reduce((summary, source) => {
    const label = source.label.trim();
    const words = label.split(/\s+/);
    if (words.length <= 6) return summary;
    return summary.split(label).join(`${words.slice(0, 6).join(' ')}…`);
  }, displayAuditText(text, sources));
